import actions from './actions';

const {
  getUsersExperimentBegin,
  getUsersExperimentSuccess,
  getUsersExperimentErr,
  setUsersExperimentBegin,
  setUsersExperimentSuccess,
  setUsersExperimentErr,
} = actions;

const getUsersExperimentAction = () => {
  return async dispatch => {
    try {
      dispatch(getUsersExperimentBegin());
      dispatch(getUsersExperimentSuccess());
    } catch (err) {
      dispatch(getUsersExperimentErr(err));
    }
  };
};

const setUsersExperimentAction = selectedSymbol => {
  return async dispatch => {
    try {
      dispatch(setUsersExperimentBegin());
      dispatch(setUsersExperimentSuccess(selectedSymbol));
    } catch (err) {
      dispatch(setUsersExperimentErr(err));
    }
  };
};

export { getUsersExperimentAction, setUsersExperimentAction };
